import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';

declare var H: any;

@Component({
  selector: 'here-map',
  templateUrl: './here-map.component.html',
  styleUrls: ['./here-map.component.css']
})
export class HereMapComponent implements OnInit {

  @ViewChild("map")
  public mapElement: ElementRef;

  @Input()
  public appKey: any;

  @Input()
  public lat: any;

  @Input()
  public lng: any;

  @Input()
  public width: any;

  private _height: any;
  @Input()
  public height: any;

  private platform: any;
  private map: any;
  private ui: any;
  private search: any;

  public constructor() { }

  public ngOnInit() {
    this.platform = new H.service.Platform({
      "apikey": this.appKey,
    });
  }

  public addDomMarker(lat: number, lng: number) {
    if (lat && lat !== 0 && lng && lng !== 0) {
      let defaultLayers = this.platform.createDefaultLayers();
      this.map = new H.Map(
        this.mapElement.nativeElement,
        defaultLayers.vector.normal.map,
        {
          zoom: 12,
          center: { lat: lat, lng: lng }
        }
      );
      let behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(this.map));
      this.ui = H.ui.UI.createDefault(this.map, defaultLayers, 'fr-FR');

      //console.log('lat: ' + lat + ' | lng: ' + lng);
      const parisMarker = new H.map.Marker({ lat: lat, lng: lng });
      this.map.addObject(parisMarker);
    }
  }

  public resize() {
    this.map.getViewPort().resize();
  }



}
